import { BigNum } from '@velocity-exchange/sdk';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';

export const RentDisclaimers = ({
	accountExists,
	totalAccountCreationCost,
	hasEnoughSolInWallet,
	solRequiredToDeposit,
	isLoadingWalletBalance,
}: {
	accountExists: boolean;
	totalAccountCreationCost: BigNum;
	hasEnoughSolInWallet: boolean;
	solRequiredToDeposit: BigNum;
	isLoadingWalletBalance: boolean;
}) => {
	if (isLoadingWalletBalance) {
		return null;
	}

	return (
		<>
			{!accountExists && hasEnoughSolInWallet && (
				<span className="typo-body-xs text-text-secondary">
					Reclaimable account setup fee:{' '}
					{totalAccountCreationCost.prettyPrint(true, 1)} SOL
				</span>
			)}
			{!hasEnoughSolInWallet && (
				<InlineAlert variant="error" title="Not enough SOL in your wallet">
					{solRequiredToDeposit.prettyPrint(true, 4)} SOL is needed{' '}
					{accountExists
						? 'to cover for future transaction gas fees'
						: 'to cover a new sub-account creation fees (refundable after closing the account) and gas fees'}
				</InlineAlert>
			)}
		</>
	);
};
